import { render, staticRenderFns } from "./dropbox.vue?vue&type=template&id=3cffc2ee&"
import script from "./dropbox.vue?vue&type=script&lang=js&"
export * from "./dropbox.vue?vue&type=script&lang=js&"
import style0 from "./dropbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports